import { Company, Product } from '../../services/interface/Shared';
import { PHONE_NUMBERS, PhoneNumber, PhoneUsage } from '../constants';

const defaultPhoneNumbers: Record<PhoneUsage, PhoneNumber> = {
	CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
	CONTACT: PHONE_NUMBERS.DEFAULT_CONTACT_NUMBER,
	WINDSCREEN: PHONE_NUMBERS.DEFAULT_WINDSCREEN_NUMBER,
	KEYCARE: PHONE_NUMBERS.DEFAULT_KEYCARE_NUMBER,
	EXISTING_CLAIM: PHONE_NUMBERS.DEFAULT_EXISTING_CLAIM_NUMBER,
	BD: PHONE_NUMBERS.DEFAULT_BD_NUMBER,
	RENEWAL: PHONE_NUMBERS.DEFAULT_RENEWAL_NUMBER,
	CANCELLED: PHONE_NUMBERS.DEFAULT_CANCELLED_NUMBER,
	AUTO_RENEW_CONTACT: PHONE_NUMBERS.DEFAULT_AUTO_RENEW_CONTACT_NUMBER,
};

const productPhoneNumbers: Partial<Record<string, Partial<Record<Product | string, any>>>> = {
	Acorn: {
		[Product.TAXI]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.TAXI_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.ACORN_CANCELLED_NUMBER,
			AUTO_RENEW_CONTACT: PHONE_NUMBERS.TAXI_AUTO_RENEW_CONTACT_NUMBER,
		},
		[Product.COMMERCIAL_VEHICLE]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.DEFAULT_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.ACORN_CANCELLED_NUMBER,
		},
		[Product.PRIVATE_CAR]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.DEFAULT_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.ACORN_CANCELLED_NUMBER,
		},
		[Product.TELEMATICS]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.ACORN_TELEMATICS_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.ACORN_CANCELLED_NUMBER,
			AUTO_RENEW_CONTACT: PHONE_NUMBERS.PROTECT_YD_AUTO_RENEW_CONTACT_NUMBER,
		},
		[Product.SHORT_TERM]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.DEFAULT_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.ACORN_CANCELLED_NUMBER,
		},
	},
	Motorcade: {
		[Product.PRIVATE_CAR]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.MOTORCADE_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.ACORN_CANCELLED_NUMBER,
			AUTO_RENEW_CONTACT: PHONE_NUMBERS.MOTORCADE_AUTO_RENEW_CONTACT_NUMBER,
		},
	},
	Carrot: {
		[Product.CARROT]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.CARROT_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.CARROT_CANCELLED_NUMBER,
			AUTO_RENEW_CONTACT: PHONE_NUMBERS.CARROT_AUTO_RENEW_CONTACT_NUMBER,
		},
	},
	Flag: {
		[Product.TAXI]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.FLAG_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.FLAG_CANCELLED_NUMBER,
			AUTO_RENEW_CONTACT: PHONE_NUMBERS.FLAG_AUTO_RENEW_CONTACT_NUMBER,
		},
	},
	MyPolicy: {
		[Product.TELEMATICS]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.MYPOLICY_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.MYPOLICY_CANCELLED_NUMBER,
			AUTO_RENEW_CONTACT: PHONE_NUMBERS.MYPOLICY_AUTO_RENEW_CONTACT_NUMBER,
		},
	},
	StreetCover: {
		[Product.PRIVATE_CAR]: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.STREETCOVER_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.STREETCOVER_CONTACT_NUMBER,
		},
		STREETCOVER: {
			CLAIMS: PHONE_NUMBERS.DEFAULT_CLAIMS_NUMBER,
			CONTACT: PHONE_NUMBERS.STREETCOVER_CONTACT_NUMBER,
			CANCELLED: PHONE_NUMBERS.STREETCOVER_CONTACT_NUMBER,
		},
	},
};

function getPhoneNumber(product: keyof typeof Product, usage: PhoneUsage) {
	const company = import.meta.env.VITE_AUTH_REALM as Company;
	return productPhoneNumbers[company]?.[product]?.[usage] || defaultPhoneNumbers[usage];
}
export default getPhoneNumber;
